import img1 from "./images/illustration/brand-1.png";
import img2 from "./images/illustration/brand-2.png";
import img3 from "./images/illustration/brand-3.png";
import img4 from "./images/illustration/brand-4.png";

const Gym = () => {
  return (
    <>
      <section className=" container-fluid text-centre" id="demo9">
        <section className="container text-center mt-5">
          <section className="row py-5">
            <div className="col-12 "></div>
            <div className="col-xl-3 col-12 col-md-6 mt-5">
              <img src={img1} alt="image not found" className="img-fluid" />
            </div>

            <div className=" col-xl-3 col-12 col-md-6 mt-5">
              <img src={img2} className="img-fluid" />
            </div>
            <div className=" col-xl-3 col-12 col-md-6 mt-5">
              <img src={img3} alt="image not found" className="img-fluid" />
            </div>
            <div className=" col-xl-3 col-12 col-md-6 mt-5">
              <img src={img4} alt="image not found" className="img-fluid" />
            </div>
          </section>
        </section>
      </section>
    </>
  );
};

export default Gym;
